// src/components/Layout/ToastContainer.jsx
import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { removeToast } from '../../store/slices/toastsSlice.js';

export default function ToastContainer() {
  const toasts = useSelector((s) => s.toasts);
  const dispatch = useDispatch();

  if (!toasts.length) return null;

  return (
    <div
      className="toast-container"
      role="region"
      aria-live="polite"
      aria-label="Notifications"
    >
      {toasts.map((t) => (
        <div
          key={t.id}
          className={`toast ${t.type}`}
          onClick={() => dispatch(removeToast(t.id))}
          role="status"
        >
          {t.type === 'success' && <span style={{ marginRight: 6 }}>✓</span>}
          {t.type === 'error' && <span style={{ marginRight: 6 }}>✕</span>}
          {t.message}
        </div>
      ))}
    </div>
  );
}
